import { CircularProgress } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";

export function SimpleLoader(props) {
    return(
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                p: 1,
                m: 1,
                bgcolor: 'background.paper',
                borderRadius: 1,
                borderColor: "#e7e7e7",
            }}
        >
            <CircularProgress disableShrink/>
        </Box>
    )
}